import React from 'react';
import { motion } from 'framer-motion';
import { trackMeta } from './MetaPixel';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} className={className} data-id="element-404">
    {children}
  </motion.div>;
interface TrackEvent {
  name: string;
  params?: Record<string, any>;
  custom?: boolean;
}
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  trackEvent?: TrackEvent;
}
export const CTAButton = ({
  href,
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  trackEvent,
  onClick,
  ...props
}: ButtonProps) => {
  const isExternal = /^https?:\/\//.test(href);
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    if (trackEvent) {
      trackMeta(trackEvent.name, trackEvent.params, {
        custom: trackEvent.custom
      });
    }
    if (onClick) onClick(e);
  };
  return <a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`
        inline-flex items-center justify-center gap-2.5 font-bold rounded-full transition-all duration-300 transform hover:scale-[1.03] shadow-lg leading-none text-center
        ${fullWidth ? 'w-full px-6' : 'px-10'} py-5 md:py-6 text-lg md:text-2xl
        ${variant === 'primary' ? 'bg-brandOrange hover:bg-brandOrange-hover text-white animate-glow-button' : 'bg-white text-navy hover:bg-gray-50 border-2 border-navy'}
        ${className}
      `} {...props} data-id="element-405">
      {children}
    </a>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`pt-6 md:pt-10 pb-[50px] px-4 md:px-8 overflow-hidden ${className}`} data-id="element-406">
    <div className="max-w-6xl mx-auto" data-id="element-407">{children}</div>
  </section>;